import {
  ADMIN_APPTS_LIST_REQUEST,
  ADMIN_APPTS_LIST_SUCCESS,
  ADMIN_APPTS_LIST_FAIL,
  ADMIN_APPT_ASSIGN_REQUEST,
  ADMIN_APPT_ASSIGN_SUCCESS,
  ADMIN_APPT_ASSIGN_FAIL,
  ADMIN_APPT_REJECT_REQUEST,
  ADMIN_APPT_REJECT_SUCCESS,
  ADMIN_APPT_REJECT_FAIL,
  ADMIN_APPT_COMPLETE_REQUEST,
  ADMIN_APPT_COMPLETE_SUCCESS,
  ADMIN_APPT_COMPLETE_FAIL,
  ADMIN_APPT_REPORT_REQUEST,
  ADMIN_APPT_REPORT_SUCCESS,
  ADMIN_APPT_REPORT_FAIL,
  ADMIN_PAYMENT_REQUEST,
  ADMIN_PAYMENT_SUCCESS,
  ADMIN_PAYMENT_FAIL,
} from "../../constants/adminConstants/adminAppointmentConstants.js";

const initialState = {
  appointments: [],
  report: [],
  loading: false,
  error: null,
  paymentSuccess: false,
  paymentAppointment: null,
};

// helper: safely extract appointment from payload
const getUpdatedAppointment = (payload) => {
  if (!payload) return null;
  if (payload.appointment) return payload.appointment;
  return payload; // backend sends direct appointment object
};

export const adminAppointmentsReducer = (state = initialState, action) => {
  switch (action.type) {
    // ===== REQUEST STATES =====
    case ADMIN_APPTS_LIST_REQUEST:
    case ADMIN_APPT_ASSIGN_REQUEST:
    case ADMIN_APPT_REJECT_REQUEST:
    case ADMIN_APPT_COMPLETE_REQUEST:
    case ADMIN_APPT_REPORT_REQUEST:
    case ADMIN_PAYMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        paymentSuccess: false,
      };

    // ===== LIST SUCCESS =====
    case ADMIN_APPTS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        appointments: action.payload,
      };

    // ===== SINGLE UPDATE SUCCESS (assign / reject / complete) =====
    case ADMIN_APPT_ASSIGN_SUCCESS:
    case ADMIN_APPT_REJECT_SUCCESS:
    case ADMIN_APPT_COMPLETE_SUCCESS: {
      const updated = getUpdatedAppointment(action.payload);
      if (!updated) return { ...state, loading: false };

      return {
        ...state,
        loading: false,
        appointments: state.appointments.map((a) =>
          a._id === updated._id ? updated : a
        ),
      };
    }

    // ===== REPORT SUCCESS =====
    case ADMIN_APPT_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        report: action.payload,
      };

    // ===== PAYMENT SUCCESS =====
    case ADMIN_PAYMENT_SUCCESS: {
      const updated = getUpdatedAppointment(action.payload);
      if (!updated) return { ...state, loading: false };

      return {
        ...state,
        loading: false,
        paymentSuccess: true,
        paymentAppointment: updated,
        appointments: state.appointments.map((a) =>
          a._id === updated._id ? updated : a
        ),
      };
    }

    // ===== FAIL STATES =====
    case ADMIN_APPTS_LIST_FAIL:
    case ADMIN_APPT_ASSIGN_FAIL:
    case ADMIN_APPT_REJECT_FAIL:
    case ADMIN_APPT_COMPLETE_FAIL:
    case ADMIN_APPT_REPORT_FAIL:
    case ADMIN_PAYMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
